import React from 'react';
import { Link } from 'react-router-dom';
import { PageHero } from '../components/PageHero';
import { ContactForm } from '../components/ContactForm';
import { ContactDetails } from '../components/ContactDetails';
import { SectionHeading } from '../components/SectionHeading';
import { counties, featuredCities } from '../data/serviceAreas';
import { site } from '../data/site';
export function Contact() {
  return <>
      <PageHero eyebrow="Contact" title="Schedule a free estimate" description="Call, e-mail or send the form below. Estimates and consultations are free." crumbs={[{
      label: 'Home',
      to: '/'
    }, {
      label: 'Contact'
    }]} data-id="element-298" data-mp="y1qpsuwefb3g" />

      <section className="mx-auto grid max-w-7xl gap-10 px-6 py-12 lg:grid-cols-[1fr_1.2fr] md:py-16" data-id="element-299" data-mp="12zscrqwy3uk7">
        <ContactDetails data-id="element-300" data-mp="f9xz574sy1yw" />
        <div data-id="element-301" data-mp="f9ekbzag7tp3">
          <ContactForm data-id="element-302" data-mp="f8wmwzc1v9fl" />
          <p className="mt-4 text-sm leading-relaxed text-steel-500" data-id="element-303" data-mp="f83d1phso3t8">
            Prefer the phone? Estimates:{' '}
            <a href={site.estimatePhone.href} className="font-semibold text-ink hover:text-safety" data-id="element-304" data-mp="a9a7cj8r1h3m">
              {site.estimatePhone.display}
            </a>{' '}
            ({site.estimatePhone.alt}). Plumbing:{' '}
            <a href={site.plumbingPhone.href} className="font-semibold text-ink hover:text-safety" data-id="element-305" data-mp="1e8abyy3eej04">
              {site.plumbingPhone.display}
            </a>
            .
          </p>
        </div>
      </section>

      <section className="border-t border-steel-200 bg-white" data-id="element-306" data-mp="qhwf8u9vbvz7">
        <div className="mx-auto max-w-7xl px-6 py-12" data-id="element-307" data-mp="qk8x77fmm6c9">
          <SectionHeading eyebrow="Coverage" title="Who we can come out to" description={`${counties.join(', ')} Counties in Michigan.`} data-id="element-308" data-mp="vgzkaepum276" />
          <div className="mt-5 flex flex-wrap gap-2" data-id="element-309" data-mp="26wxs6f9aii6t">
            {featuredCities.map(c => <span key={c} className="rounded-sm border border-steel-200 px-3 py-1.5 text-sm text-ink-700" data-id="element-310" data-mp="2buzjfngvdntd">
                {c}
              </span>)}
          </div>
          <Link to="/service-area" className="mt-5 inline-block text-sm font-bold uppercase tracking-wide text-safety hover:underline" data-id="element-311" data-mp="1h7h6xce5bjza">
            See every city →
          </Link>
        </div>
      </section>
    </>;
}